/*
 * Проверяет, является ли строка UUID.
 * Проверка выполняется по длине строки и позициям дефисов (более производительный вариант, нежели регулярка).
 * UUID формат: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx (36 символов)
 */
export const isUuid = (str: string): boolean =>
    str.length === 36 && str[8] === '-' && str[13] === '-' && str[18] === '-' && str[23] === '-';
